import { render, staticRenderFns } from "./OpenTokPublisher.vue?vue&type=template&id=5268cfb0&"
import script from "./OpenTokPublisher.vue?vue&type=script&lang=js&"
export * from "./OpenTokPublisher.vue?vue&type=script&lang=js&"
import style0 from "./OpenTokPublisher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports